import React from "react";
import { useLoader } from "../context/LoadingContext";

const FullScreenLoader: React.FC = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="flex flex-col items-center space-y-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
        <p className="text-lg font-semibold text-white">Loading...</p>
      </div>
    </div>
  );
};

export default FullScreenLoader;
